export default "/images/middle@2x.png?0a0f35dcc674d77b7a36cd1125c39cf2";